module.exports = __webpack_public_path__ + "static/media/Grey-headed-canary-flycatcher-template.6b051b5a.wav";